export enum ChartUnitEnum {
  EURO = "€",
  PERCENT = "%",
  UNIT = "",
}
